// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".transaction-bar{border-bottom:1px solid #f0f0f0}.transaction-bar img{-o-object-fit:contain;object-fit:contain;width:50px;height:50px}.transaction-bar__left-col .f-16{font-size:13px}.transaction-bar__left-col--text .pale{color:rgba(26,26,26,.3)}@media (max-width:413px){.transaction-bar__left-col--text .pale{font-size:13px}}", ""]);
// Exports
module.exports = exports;
